<marlenka-stepper
  #marlenkaStepper
  [steps]="reservationSteps"
  (stepsCompleted)="onVoucherCompleted()"
  (backClicked)="backClicked.emit($event)"
></marlenka-stepper>
